import React from 'react';
import { Input } from 'antd';

import Base from './Base';

const AntTextArea = props => <Base {...props} component={Input.TextArea} />;

export default AntTextArea;
